// Display preferences kept in localStorage. Signing out clears localStorage, so these
// keys are carried over by clearLocalStorageKeepingPreferences().
export const PHOTOS_SORT_KEY = 'photos-sort';

const PREFERENCE_KEYS = [PHOTOS_SORT_KEY];

export function readPreference(key) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (e) {
    return null;
  }
}

export function savePreference(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Storage blocked or full: the preference just isn't remembered.
  }
}

export function clearLocalStorageKeepingPreferences() {
  const kept = PREFERENCE_KEYS.map((key) => [key, localStorage.getItem(key)]);
  localStorage.clear();
  kept.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value);
  });
}
